import React from 'react';
import { Chip } from '@mui/material';
import { Text, Theme, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import CoverageBlock from '../../components/CoverageBlock.js';
import store from '../../redux/store.js';

/**
 *
 * @param {*} props
 */
export default function OutOfCountry({ classes, expanded, outOfCountry, handleChange, theme, showDependentWarning, waivedEHC }) {
    const language = store.getState().user.meta.language || 'en';
    let bookletLink = '';

    switch (outOfCountry.carrier) {
        case 'La Capitale':
            bookletLink = "https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_La Capitale.pdf";
            break;
        case 'Desjardins':
            bookletLink = language === 'fr' ? "https://d6hvupc5g7lnm.cloudfront.net/files/Voyage_Assistance_Desjardins.pdf" : "https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_Desjardins.pdf";
            break;
        case 'Empire':
            bookletLink = "https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_Empire.pdf";
            break;
        case 'Orion':
            bookletLink = "https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_Orion.pdf";
            break;
        default:
            bookletLink = "https://d6hvupc5g7lnm.cloudfront.net/files/Travel_Assistance_Guidelines_Orion.pdf";
    }

    let oocGradedString = "";
    if (outOfCountry.isGraded) {
        oocGradedString = i18n.t(tokens.labels.coverage.reducesAtAgeAndTripDurationDetails, { reducesAtAge: outOfCountry.reducesAtAge, periodAfterReduction: outOfCountry.periodAfterReduction, reducesBy: outOfCountry.reducesBy });
    }


    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('outOfCountry')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('outOfCountry') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles["out of country or province"])}</Text>
                    {
                        waivedEHC &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "0 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666'
                                }}
                            />
                    }
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        outOfCountry.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                            : 
                            null
                    }

                    {
                        showDependentWarning ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.waivedBenefitForDependents) }
                                </Text>
                            </div>
                            :
                            null
                    }

                    {
                        outOfCountry.outOfCountryMax > 0 ?
                            <div style={classes.row}>
                                <Text small bold margin="10px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.outOfCountryMedicalCoverageDetails, { outOfCountryMax: numberWithCommas(outOfCountry.outOfCountryMax) }) }
                                    { " " }
                                    { oocGradedString }
                                </Text>
                            </div>
                            :
                            null
                    }

                    {
                        outOfCountry.carrier === "AIG" ?
                            <>
                                <a
                                    href="https://aig.ca/travelguardassistance"
                                    style={{ textDecoration: 'none' }} target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Text
                                        color={store.getState().whitelabel.primaryColor || theme.colors.skyBlue}
                                        small
                                        display="block"
                                        margin="10px 0px 0px 0px"
                                    >
                                        { i18n.t(tokens.titles["aig travel guard assistance"])}
                                    </Text>
                                </a>

                                <a
                                    href="https://apps.apple.com/us/app/aig-travel-assistance/id829194220"
                                    style={{ textDecoration: 'none' }} target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Text
                                        color={store.getState().whitelabel.primaryColor || theme.colors.skyBlue}
                                        small
                                        display="block"
                                        margin="10px 0px 0px 0px"
                                    >
                                        { i18n.t(tokens.labels.coverage.downloadAigAppOnAppleStore) }
                                    </Text>
                                </a>

                                <a
                                    href="https://play.google.com/store/apps/details?id=com.aig.android.travelguard"
                                    style={{ textDecoration: 'none' }} target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Text
                                        color={store.getState().whitelabel.primaryColor || theme.colors.skyBlue}
                                        small
                                        display="block"
                                        margin="10px 0px 0px 0px"
                                    >
                                        { i18n.t(tokens.labels.coverage.downloadAigAppOnGooglePlay) }
                                    </Text>
                                </a>
                            </>
                            :
                            <a
                                href={ bookletLink }
                                download="Travel Assistance Guidelines.pdf"
                                style={{ textDecoration: 'none' }} target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Text
                                    color={store.getState().whitelabel.primaryColor || theme.colors.skyBlue}
                                    small
                                    display="block"
                                    margin="10px 0px 0px 0px"
                                >
                                    { i18n.t(tokens.labels.coverage.travelAssistanceGuidelines) }
                                </Text>
                            </a>
                    }

                    <React.Fragment>
                        <CoverageBlock
                            title={ i18n.t(tokens.labels.type) }
                            value={ i18n.t(tokens.labels.coverage.upTo) }
                            type="header"
                        />
                        <CoverageBlock
                            title={ i18n.t(tokens.titles.outOfCountry) }
                            value={ outOfCountry.outOfCountryMax }
                        />


                        {
                            outOfCountry.outOfCountryMedicalReferralMax > 0 ?
                                <CoverageBlock
                                    title={ i18n.t(tokens.labels.coverage.outOfCountryMedicalReferral) }
                                    value={ outOfCountry.outOfCountryMedicalReferralMax }
                                />
                                : 
                                null
                        }

                        {
                            outOfCountry.outOfCountryMedicalReferralReimbursement > 0 ?
                                <CoverageBlock
                                    title={ i18n.t(tokens.labels.coverage.outOfCountryReferralReimbursement) }
                                    value={outOfCountry.outOfCountryMedicalReferralReimbursement}
                                    type="percent"
                                />
                                : 
                                null
                        }

                        <CoverageBlock
                            title={ i18n.t(tokens.labels.coverage.tripDuration) }
                            value={ outOfCountry.period }
                            type={ "days" }
                        />

                        {
                            outOfCountry.outOfCountryRollover && 
                                <CoverageBlock
                                    title={ i18n.t(tokens.labels.coverage.coverageRolloverPeriod) }
                                    value={ localizationMaps.fromEnglish("oocOptions", outOfCountry.outOfCountryRollover) }
                                    type="age"
                                />
                        }

                    </React.Fragment>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}